export default __webpack_public_path__ + "static/media/59-DoArtFoundation.c41d16a8.jpg";